import { useContext } from 'react';
import { getPatchedFieldClassName } from 'state/formData/patchedFields/patchedFields.helper';
import { areLegacyInvalidFields, type InvalidFields } from 'state/selectors/meta/static/utils';

import { InvalidFieldsContext } from '../contexts/InvalidFieldsContext';
import { PatchedFieldsContext } from '../contexts/PatchedFieldsContext';
import { useFieldMetadata } from './useFieldMetadata';
import { getFirstVisibleValidationError } from './useFieldValidationError';

function hasVisibleValidationError(invalidFields: InvalidFields, fieldId: string): boolean {
  if (areLegacyInvalidFields(invalidFields)) {
    return false;
  }
  return getFirstVisibleValidationError(invalidFields[fieldId]) !== undefined;
}

export function usePatchedFieldHighlight(fieldId: string): string | undefined {
  const { fields, pulseParity } = useContext(PatchedFieldsContext);
  const invalidFields = useContext(InvalidFieldsContext);
  const metadata = useFieldMetadata(fieldId);

  if (hasVisibleValidationError(invalidFields, fieldId)) {
    return undefined;
  }
  if (metadata?.isHighlighted) {
    return undefined;
  }
  const isFieldPatched = fields.includes(fieldId) || fields.some(field => field.startsWith(`${fieldId}::`));
  if (!isFieldPatched) {
    return undefined;
  }

  return getPatchedFieldClassName(pulseParity, fieldId);
}
